import { useQuery } from '@apollo/client/react'
import type { ApolloUseQueryResult } from '@vivaldis/graphql'
import { createContext, PropsWithChildren, useContext, useMemo } from 'react'
import {
  UnansweredSafetyQuestionsTabQuery,
  UnansweredSafetyQuestionsTabQuery_unansweredSafetyQuestions,
  UnansweredSafetyQuestionsTabQueryVariables
} from '../graphql/__generated__/UnansweredSafetyQuestionsTabQuery'
import { useParams } from '../../../hooks/useParams'
import { unansweredUnansweredSafetyQuestionsTabQuery } from '../graphql/unansweredSafetyQuestionsTabQuery'

export type QueryContextValue = ApolloUseQueryResult<
  UnansweredSafetyQuestionsTabQuery,
  UnansweredSafetyQuestionsTabQueryVariables,
  'empty' | 'complete' | 'streaming',
  UnansweredSafetyQuestionsTabQueryVariables
>

export const QueryContext = createContext<QueryContextValue | undefined>(
  undefined
)

export function useUnansweredSafetyQuestionsTabQuery(): QueryContextValue {
  return useContext(QueryContext)!
}

export function useUnansweredSafetyQuestions(): UnansweredSafetyQuestionsTabQuery_unansweredSafetyQuestions[] {
  const { data } = useUnansweredSafetyQuestionsTabQuery()

  return useMemo(() => {
    return data?.unansweredSafetyQuestions || []
  }, [data])
}

export const UnansweredSafetyQuestionsTabQueryProvider = ({
  children
}: PropsWithChildren<unknown>) => {
  const { employeeId } = useParams()

  const queryResult = useQuery(unansweredUnansweredSafetyQuestionsTabQuery, {
    variables: {
      employeeId
    }
  })

  return (
    <QueryContext.Provider value={queryResult}>
      {children}
    </QueryContext.Provider>
  )
}
